import React, { useEffect, useState } from 'react'
import ChatBotPlanDetailsBot from './payment_bot';
import { API_ROUTE_CONTROLLER } from '../../../service/route';
import { PARENT_ID, PLAN_ID, PLAN_PURPOSE_INFO } from '../../../service/constant';
import { ApiServices } from '../../../app/base/service/apiService';
import { setPaymentBotData, setPlanInfo } from '../../../store/user';
import { useDispatch } from 'react-redux';
import Loaders from '../../loader';
import { setAddonGetList, updateLogin } from '../../../store/login';
import { LoginService } from '../../../service/login';
import { setAddons, setCarts, setProducts } from '../../../store/constant';
import UpgardeDetailsCcaasBot from './ccaas_payment_bot';
import { useNavigate } from 'react-router-dom';
import { Cookie } from '../../../app/base/utils';
import AddonPayment from './addon_purchase';
const ls = new LoginService();

function BotPayment() {
    const [isLoader, setLoader] = useState<boolean>(true);
    const [urlSplit, setUrlSpilt] = useState<any>({});
    const [planServices, setPlanServices] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [getfilteredItems, setFilteredItems] = useState<any>([{ id: 0, addonid: 0, addon_name: "", addon_desc: "", addon_bundleid: 0, bundle_id: 0, addon_price: 0, quantity: 0, totalAmount: 0, active: false }])
    const [getCategoryWiseAddonList, setCategoryWiseAddonList] = useState<any>([]);
    const [getDatas3, setDatas3] = useState<any>([]);
    const [getDatas33, setDatas33] = useState<any>([]);
    const [addonIdVal, setAddonIdVal] = useState<any>("");
    const [getDatas, setDatas] = useState<any>([]);
    const [getDatas2, setDatas2] = useState<any>([]);
    async function parseAndDecodeUrl(url) {
        const result = {};
        const queryString = url.split('?')[1] || '';
        queryString.split('&').forEach(pair => {
            if (!pair) return;
            const [rawKey, rawValue = ''] = pair.split('=');
            const key = decodeURIComponent(rawKey);
            const valString = decodeURIComponent(rawValue);
            // Attempt to Base64-decode
            let decoded = valString;
            try {
                decoded = atob(valString);
            } catch {
                // If not valid Base64, keep original
                decoded = valString;
            }
            // Try parsing JSON, fallback to plain text
            let parsed;
            try {
                parsed = JSON.parse(decoded);
            } catch {
                parsed = decoded;
            }
            result[key] = parsed;
        });
        return result;
    }

    const repeatedUrlFunc = (data, res) => {
        let flag = false;
        console.log("repeated", data?.detail?.upgradePlanId == res?.data?.result[0]?.plan_id, (res.data.result[0]?.Is_free_trail == 0 || res.data.result[0]?.free_Paid == 2))
        if (data?.detail?.upgradePlanId == PLAN_ID.LOLA || data?.detail?.upgradePslanId == PLAN_ID.ENTERPRISE) flag = true;
        if ((res?.data?.result[0]?.plan_id == PLAN_ID.LUKAS || res?.data?.result[0]?.plan_id == PLAN_ID.PRO) && (res.data.result[0]?.Is_free_trail == 0 || res.data.result[0]?.free_Paid == 2)) flag = true;
        if (data?.detail?.upgradePlanId == res?.data?.result[0]?.plan_id && (res.data.result[0]?.Is_free_trail == 0 || res.data.result[0]?.free_Paid == 2)) flag = true;
        console.log("flag", flag)
        if (flag) {
            Cookie.clear();
            navigate('/')
            return
        }
    }
    const getBillServicePlan = async (data) => {
        const _url = API_ROUTE_CONTROLLER.UrgetBillServicePlan;
        const _body = {
            company_id: data?.detail?.companyId,
        };
        const res = await ApiServices.post(_body, _url);
        dispatch(setProducts(res.data.result))
        setPlanServices(res.data.result[0]);
        if (data?.type != "addon_purchase") {
            repeatedUrlFunc(data, res);
        }else{
            if(res.data.result[0]?.Is_free_trail == 1 || res.data.result[0]?.free_Paid == 1){
                Cookie.clear();
                navigate('/');
            }
        }
        return res.data.result;
    };
    const planPurposeInfo = async (newUrlSpilt) => {
        let _url = API_ROUTE_CONTROLLER.getTirePlanPurposeInfo;
        let _body = {
            purpose_id: PLAN_PURPOSE_INFO.PURPOSE_ID,
            product_id: newUrlSpilt?.detail?.upgradeProductId,
            prod_type_id: newUrlSpilt?.detail?.upgradeProductId,
            p_country_id: PLAN_PURPOSE_INFO.COUNTRY_ID,
        };
        const getPlan: any = await ApiServices.post(_body, _url);
        const upgradePlan = getPlan.data.result.filter((item) => item.cop_description == newUrlSpilt?.detail?.duration && item?.tier_id == newUrlSpilt?.detail?.upgradePlanId)
        let parsedData = JSON.parse(upgradePlan[0].platform_fee_json_info)
        let platform_fee = newUrlSpilt?.detail?.duration == "1 month" ? parsedData[0].platform_fee_month_price : parsedData[0].platform_fee_yearly_price
        console.log("parsedData", parsedData, platform_fee)
        let conversationCount = parsedData[0].platform_fee_count;
        if (newUrlSpilt?.detail?.upgradeProductId == 15) {
            upgradePlan[0].platform_fee = platform_fee;
            localStorage.setItem("platformfee", platform_fee)
            localStorage.setItem("conversationCount", conversationCount)
        }
        dispatch(setPlanInfo(upgradePlan));
        console.log("upgradePlan", upgradePlan)
        setLoader(false)
    }
    const loginApi = async (data) => {
        const res = await ls.login(data?.detail?.email.trim(), data?.detail?.password.trim(), false);
        if (res && res.length) {
            if (res[0].errcode == 0) {
                dispatch(updateLogin(res[0]));
            }
        }
    }
    const worktualGetProdWiseAddonList = async (newUrlSpilt, getBillService) => {
        try {
            let _url2 = API_ROUTE_CONTROLLER.worktualGetProdWiseAddonList;
            let _body2 = {
                "category_id": 0,
                "tier_id": getBillService?.[0]?.plan_id,
                "product_id": 0
            };
            const ProdWiseAddonList: any = await ApiServices.post(_body2, _url2)
            if (ProdWiseAddonList.data.message == 'Success') {
                setCategoryWiseAddonList(ProdWiseAddonList.data.result);
                const filteredItems1 = ProdWiseAddonList.data.result.map(item => {
                    if (getBillService[0]?.plan_id > 0) {
                        const stringTierID = getBillService[0]?.plan_id.toString();
                        const array_tier_Ids = item.tier_Id;
                        const dataArray = array_tier_Ids.split(',');
                        const isValuePresent = dataArray.includes(stringTierID);
                        return ({ ...item, addonStatus: isValuePresent })
                    }
                    else {
                        return item;
                    }
                });
                let finaladdonList: any = filteredItems1.map((a: any, index: any) => ({
                    id: index + 3,
                    category_id: a.category_id,
                    addonid: a.addon_feature_id,
                    addon_name: a.addon_feature_name,
                    addon_desc: a.addon_feature_description,
                    addon_bundleid: a.addon_feature_id,
                    bundle_id: a.bundle_id,
                    addon_price: a.addon_price,
                    quantity: 0,
                    totalAmount: 0,
                    active: false,
                    status: a.status,
                    addonStatus: a.addonStatus,
                    image_name: a.image_name
                }));
                if (finaladdonList.length > 0) {
                    setDatas3(finaladdonList);
                    setFilteredItems(finaladdonList);
                    setDatas33(finaladdonList);
                    let filterAddOn = finaladdonList.filter(ele => ele?.addonid == newUrlSpilt?.detail?.addonId)
                    console.log("filterAddOn", filterAddOn)
                    // const usersAndNumbers = [
                    //     {
                    //         "id": 0,
                    //         "addonid": 0,
                    //         "addon_name": login.ccas_role_info == '3' || login.ccas_role_info == '1' ? "Additional seat(s)" : "Additional user(s)",
                    //         "addon_desc": login.ccas_role_info == '3' || login.ccas_role_info == '1' ? "Additional seat(s)" : "Additional user(s)",
                    //         "addon_bundleid": 0,
                    //         "bundle_id": 0,
                    //         "category_id": 0,
                    //         "addon_price": _billing_details.pc_price > 0 ? parseInt(_billing_details.pc_price) : 14,
                    //         "quantity": 0,
                    //         "totalAmount": 0,
                    //         "active": false
                    //     },
                    // ]

                    // setusersAndNumbers(usersAndNumbers);
                    // getfeaturelist_bycompanyproduct(usersAndNumbers);
                    await buyNow(filterAddOn, filterAddOn[0]?.addon_bundleid)
                }
                setLoader(false);
            }
            else {
                setLoader(false);
            }
        } catch (error) {
            console.log("API error");
        } finally {
        }

    }
    const buyNow = (getDatas3: any, id: any) => {
        setAddonIdVal(id)
        console.log("getDatas3", getDatas3, id)
        const countt = 1;
        const newRows3 = getDatas3.map(row => {
            if (row.addon_bundleid === id) {
                const countt = parseInt(row.quantity + 1);
                const total = row.addon_price * countt;
                return { ...row, active: true, quantity: countt, totalAmount: total };
            }
            return row;
        });
        setDatas3(newRows3);

        const newRows33 = getDatas33.map(row => {
            if (row.addon_bundleid === id) {
                const countt = parseInt(row.quantity + 1);
                const total = row.addon_price * countt;
                return { ...row, active: true, quantity: countt, totalAmount: total };
            }
            return row;
        });
        setDatas33(newRows33);

        const addToCart = getDatas.filter((item: any) => { if (item.quantity !== 0) { return item; } });
        const addToCart2 = getDatas2.filter((item: any) => { if (item.quantity !== 0) { return item; } });
        const addToCart3 = newRows3.filter((item: any) => { if (item.quantity !== 0) { return item; } });
        let mergeArray = addToCart.concat(addToCart2);
        let mergeArrayData = mergeArray.concat(addToCart3);
        if (mergeArrayData.length > 0) {
            let addToCart_string = JSON.stringify(mergeArrayData);
            localStorage.setItem('Addons', addToCart_string);
            dispatch(setAddons(mergeArrayData))
            dispatch(setCarts(mergeArrayData))
        }
        // addon Count
        const filterCounts = mergeArrayData.filter((item: any) => { if (item.quantity > 0) { return item; } });
        const count2 = filterCounts.length;
        // setCount(count2);

        // if (id == 578 || id == 579 || id == 580 || id == 581 || id == 587 || id == 590 || id == 732 || id == 730 || id == 615 || id == 792) {
        //   setNumberShowMapping(true)
        // } else {
        //   navigate('/payment-confirm')
        // }

    }
    useEffect(() => {
        const url = window.location.href;
        const init = async () => {
            let newUrlSpilt: any = await parseAndDecodeUrl(url);
            console.log("newUrlSpilt", newUrlSpilt);
            if (!newUrlSpilt?.type || !newUrlSpilt?.detail) {
                navigate('/');
                Cookie.clear();
                return;
            }
            setUrlSpilt(newUrlSpilt);
            dispatch(setPaymentBotData(newUrlSpilt))
            if (newUrlSpilt?.type == "chatbot_planUpgrade" || newUrlSpilt?.type == "ccaas_planUpgrade") {
                await planPurposeInfo(newUrlSpilt)
            }
            const getBillService = await getBillServicePlan(newUrlSpilt);
            loginApi(newUrlSpilt);
            console.log("getBillservicePlan",getBillService)
            if (newUrlSpilt?.type == "addon_purchase" && getBillService[0]?.Is_free_trail != 1) {
                await getAddonList(newUrlSpilt,getBillService)
                await worktualGetProdWiseAddonList(newUrlSpilt, getBillService)
            }

        }
        init();
    }, [window.location.href])
      const getAddonList = async (newUrlSpilt,getBillService) => {
        let _url2 = API_ROUTE_CONTROLLER.get_addon_list;
        let _body2 = {
          "company_id": getBillService[0].company_id,
        };
        const getList: any = await ApiServices.post(_body2, _url2)
        console.log("getAddonList", getList)
        const newArr = getList.data.finalresponse.map((arr) => {
          return arr?.addon_id
        })
        dispatch(setAddonGetList(getList.data.finalresponse))
        console.log("newArr", newArr)
        if(newArr.includes(newUrlSpilt?.detail?.addonId)){
            navigate('/');
            Cookie.clear();
        }
        
    
      }
    const jsonStr = JSON.stringify({
        "domainId": 20141,
        "companyId": 20214,
        "upgradeProductId": 15,
        "upgradePlanId": 160,
        "email": "fogic87569@mogash.com",
        "password": "Vectone@123",
        "firstName": "testt",
        "addonId": 553
    });
    const encoded = btoa(jsonStr);
    console.log("encodedd", encoded)
    return (
        <>
            {isLoader ? (
                <Loaders />
            ) : (
                <>
                    {urlSplit?.type === "chatbot_planUpgrade" && planServices && (
                        <ChatBotPlanDetailsBot paymentDetail={urlSplit} />
                    )}
                    {urlSplit?.type === "ccaas_planUpgrade" && planServices && (
                        <UpgardeDetailsCcaasBot paymentDetail={urlSplit} />
                    )}
                    {urlSplit?.type === "addon_purchase" && planServices && (
                        <AddonPayment paymentDetail={urlSplit} />
                    )}
                </>
            )}

        </>
    );
}

export default BotPayment;